import styled from 'styled-components';

const TaskTableSummaryLayout = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 10px 5px;
`;

const TaskTableSummaryText = styled.div<{ textSize: string }>`
  font-size: ${({ textSize }) => textSize};
  font-weight: 600px;
`;

export { TaskTableSummaryLayout, TaskTableSummaryText };
